module.exports = __webpack_public_path__ + "media/images/upload_image-51333ac4059f085e20d673c7d3633a6b.svg";